export default {"src":"/_next/static/media/pin-green-light-desktop.b17c0a0d.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};